import React from 'react';
import SchoolGradeGraph from "./2.graph/index";
import SchoolStudentStudent from "./1.list/index";

type StudentSwicthProps = {
  searchToggle: boolean;
  allClasses: string[];
  hashTags: string[];
  filteredUsers: any[];
  usersLoaded: boolean;
  schoolName: string;
  schoolId: string;
};

const StudentSwicth: React.FC<StudentSwicthProps> = ({ searchToggle, allClasses, hashTags, filteredUsers, usersLoaded, schoolName, schoolId }) => {

  return (
  <>
  {!searchToggle ?
    <SchoolStudentStudent
      hashTags={hashTags}
      filteredUsers={filteredUsers}
      usersLoaded={usersLoaded}
      schoolName={schoolName}
      schoolId={schoolId} />
  : 
    <SchoolGradeGraph
      hashTags={hashTags}
      filteredUsers={filteredUsers}
      usersLoaded={usersLoaded}
      schoolId={schoolId} /> }
  </>
  );
}

export default StudentSwicth;
